import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { WORD_STATISTICS_VALUE } from '../../data/common';
import CheckBox from '../common/CheckBox';

const wordStatisticsData = [
  {
    id: WORD_STATISTICS_VALUE.Entry,
    color: '#10BDA9',
    bgColor: '#E2FAF7',
    iconSrc:
      'https://cdn.builder.io/api/v1/image/assets/TEMP/cd2933dd505843d9d5540d8d6e483699434f105d04d6ebef1aad5a11c41bd050?placeholderIfAbsent=true&apiKey=e4c29bfc4cab4359b44d92108439cb1e',
    label: '표제어',
    count: 999,
  },
  {
    id: WORD_STATISTICS_VALUE.Derived,
    color: '#F636C9',
    bgColor: '#FCE0F6',
    iconSrc:
      'https://cdn.builder.io/api/v1/image/assets/TEMP/157227e1cf6d19fb840f2a8bc038dbc9e3f1602b57b09341fcf7b7e2e6605f09?placeholderIfAbsent=true&apiKey=e4c29bfc4cab4359b44d92108439cb1e',
    label: '파생어',
    count: 999,
  },
  {
    id: WORD_STATISTICS_VALUE.Reference,
    color: '#3D57BD',
    bgColor: '#E0EAFF',
    iconSrc:
      'https://cdn.builder.io/api/v1/image/assets/TEMP/1f7c47f31b30d5672c7a89cf50d2bf9d649e977bae7caddb1a86f97a8deeea7d?placeholderIfAbsent=true&apiKey=e4c29bfc4cab4359b44d92108439cb1e',
    label: '참고단어',
    count: 999,
  },
  {
    id: WORD_STATISTICS_VALUE.Related,
    color: '#F59E0B',
    bgColor: '#FEF3C7',
    iconSrc:
      'https://cdn.builder.io/api/v1/image/assets/TEMP/d8d3d041cb3d98268d4b3a100135c2d91d8d99517204beeac9b065cb4f4d00b9?placeholderIfAbsent=true&apiKey=e4c29bfc4cab4359b44d92108439cb1e',
    label: '관련단어',
    count: 999,
  },
];

const WordStatistics = ({ vocabularyList, checkedList, setCheckedList }) => {
  // 각 개수파악
  const counts = useMemo(() => {
    const countObj = { 1: 0, 2: 0, 3: 0, 4: 0 };
    if (vocabularyList?.length > 0) {
      vocabularyList.forEach(voca => {
        switch (voca.vc_type) {
          case WORD_STATISTICS_VALUE.Entry:
            countObj[1]++;
            break;
          case WORD_STATISTICS_VALUE.Derived:
            countObj[2]++;
            break;
          case WORD_STATISTICS_VALUE.Reference:
            countObj[3]++;
            break;
          case WORD_STATISTICS_VALUE.Related:
            countObj[4]++;
            break;
          default:
            break;
        }
      });
    }
    return countObj;
  }, [vocabularyList]);

  // 표/파/참/관 체크박스 클릭
  const handleCheck = (checked, id) => {
    if (checked) {
      setCheckedList([...checkedList, id]);
    } else {
      setCheckedList(checkedList.filter(item => item !== id));
    }
  };

  return (
    <section className="max-h-[54px] grid grid-cols-[1fr_1fr_1.1fr_1.1fr] gap-0 justify-between items-center px-2 py-2.5 text-xs font-bold leading-none whitespace-nowrap overflow-hidden border-b border-slate-300 w-full">
      {wordStatisticsData.map((item, index) => {
        const isChecked = checkedList.includes(item.id);
        return (
          <div
            key={index}
            className="flex gap-1 items-center justify-start h-[22px]"
          >
            <div
              className={`flex justify-center items-center`}
              style={{ color: item.color }}
            >
              <CheckBox
                id={item.id}
                value={item.id}
                isChecked={isChecked}
                onChange={handleCheck}
                label={item.label}
                boxStyle={{}}
                checkStyle={{
                  width: '20px',
                  height: '20px',
                  marginRight: '1px',
                }}
                labelStyle={{
                  fontWeight: 700,
                  fontSize: '12px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  height: '20px',
                  padding: '0 3px',
                  borderRadius: '3px',
                  color: item.color,
                  background: item.bgColor,
                }}
              />
            </div>
            <div className="self-stretch my-auto" style={{ color: item.color }}>
              {counts[item.id]}
            </div>
          </div>
        );
      })}
    </section>
  );
};

WordStatistics.propTypes = {
  vocabularyList: PropTypes.array.isRequired,
  checkedList: PropTypes.array.isRequired,
  setCheckedList: PropTypes.func.isRequired,
};

export default React.memo(WordStatistics);
